import { rfqRequestQuoteProductListStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";



rfqRequestQuoteProductListStyles.lineCountStyles = {
    weight: 600,
    css : css `
    ${({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        css`
            padding: 0 15px;
            `,
        css`
            padding: 0 15px;
            `,
        null,
        null,
        null,
    ])}
    `
}